import * as ToggleGroup from "@radix-ui/react-toggle-group";

import { PendoProps } from "../../utils/pendo";

import * as theme from "./SegmentedControl.css";

export interface SegmentedControlProps<Value extends string> {
    options: readonly ({ value: Value; label: string } & PendoProps)[];
    value: NoInfer<Value>;
    onChange: (value: Value) => void;
    "aria-label": string;
}

export function SegmentedControl<Value extends string>({
    options,
    value,
    onChange,
    "aria-label": ariaLabel,
}: SegmentedControlProps<Value>) {
    return (
        <ToggleGroup.Root
            type="single"
            role="radiogroup"
            orientation="horizontal"
            value={value}
            onValueChange={(nextValue) => {
                // Radix emits an empty value when the selected item is pressed.
                // Ignore it so there is always a selection.
                if (nextValue === "") {
                    return;
                }
                const option = options.find(({ value }) => value === nextValue);
                if (option) {
                    onChange(option.value);
                }
            }}
            aria-label={ariaLabel}
            className={theme.root}
        >
            {options.map((option) => (
                <ToggleGroup.Item
                    key={option.value}
                    data-pendo={option["data-pendo"]}
                    value={option.value}
                    className={theme.item}
                >
                    {option.label}
                </ToggleGroup.Item>
            ))}
        </ToggleGroup.Root>
    );
}
